export default {
  zh: 'zh-CN',
  en: 'en-US'
};
